import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { findUserByCredentials } from '../utils/userStorage'; 

const LoginForm = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    
    if (formData.email === 'admin@nekretnine.com' && formData.password === 'admin123') {
      onLogin({
        id: 1,
        name: 'Admin',
        email: formData.email,
        role: 'admin'
      });
      navigate('/admin');
      return;
    }
    
    // Provjera spremljenih korisnika
    const user = findUserByCredentials(formData.email, formData.password);
    
    if (user) {
      onLogin({
        id: user.id,
        name: user.name,
        email: user.email,
        role: user.role
      });
      navigate('/');
    } else {
      setError('Neispravni pristupni podaci');
    }
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      {error && <div style={styles.error}>{error}</div>}
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Email</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          style={styles.input}
        />
      </div>
      
      <div style={styles.formGroup}>
        <label style={styles.label}>Lozinka</label>
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          style={styles.input}
        />
      </div>
      
      <button type="submit" style={styles.button}>Prijava</button>
    </form>
  );
};

const styles = {
  form: {
    maxWidth: '400px',
    margin: '0 auto',
    padding: '2rem',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
  },
  formGroup: {
    marginBottom: '1.5rem'
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: '600'
  },
  input: {
    width: '100%',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem'
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#4a6fa5',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600'
  },
  error: {
    color: '#e74c3c',
    padding: '10px',
    marginBottom: '1rem',
    backgroundColor: '#fadbd8',
    borderRadius: '4px',
    textAlign: 'center'
  }
};

export default LoginForm;